'use client';

import React, { useEffect, useState } from 'react';

export default function StickyTicketBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.85);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`sticky-bar ${visible ? 'visible' : ''}`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <div>
          <p
            className="text-xs font-bold uppercase tracking-[0.25em]"
            style={{ color: '#D4A843' }}
          >
            Regal Portraits
          </p>
          <p
            className="text-[10px] mt-0.5"
            style={{ color: 'rgba(232,228,220,0.4)', letterSpacing: '0.05em' }}
          >
            Based in Spokane Valley
          </p>
        </div>

        <div className="flex items-center gap-3">
          <button
            className="btn-gold px-6 py-3"
            onClick={() => {
              const el = document.getElementById('packages');
              el?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            <span>View Packages</span>
          </button>
        </div>
      </div>
    </div>
  );
}